export default __webpack_public_path__ + "07dab92d59af7d2d7327721795b83c01.png";